const DashboardIcon = () => {
  return (
    <svg
      className="fill-current"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10322 0.956299H2.53135C1.5751 0.956299 0.787598 1.7438 0.787598 2.70005V6.27192C0.787598 7.22817 1.5751 8.01567 2.53135 8.01567H6.10322C7.05947 8.01567 7.84697 7.22817 7.84697 6.27192V2.72817C7.8751 1.7438 7.0876 0.956299 6.10322 0.956299ZM6.60947 6.30005C6.60947 6.5813 6.38447 6.8063 6.10322 6.8063H2.53135C2.2501 6.8063 2.0251 6.5813 2.0251 6.30005V2.72817C2.0251 2.44692 2.2501 2.22192 2.53135 2.22192H6.10322C6.38447 2.22192 6.60947 2.44692 6.60947 2.72817V6.30005Z"
        fill=""
      />
      <path
        d="M15.4689 0.956299H11.8971C10.9408 0.956299 10.1533 1.7438 10.1533 2.70005V6.27192C10.1533 7.22817 10.9408 8.01567 11.8971 8.01567H15.4689C16.4252 8.01567 17.2127 7.22817 17.2127 6.27192V2.72817C17.2127 1.7438 16.4252 0.956299 15.4689 0.956299ZM15.9752 6.30005C15.9752 6.5813 15.7502 6.8063 15.4689 6.8063H11.8971C11.6158 6.8063 11.3908 6.5813 11.3908 6.30005V2.72817C11.3908 2.44692 11.6158 2.22192 11.8971 2.22192H15.4689C15.7502 2.22192 15.9752 2.44692 15.9752 2.72817V6.30005Z"
        fill=""
      />
      <path
        d="M6.10322 9.92822H2.53135C1.5751 9.92822 0.787598 10.7157 0.787598 11.672V15.2438C0.787598 16.2001 1.5751 16.9876 2.53135 16.9876H6.10322C7.05947 16.9876 7.84697 16.2001 7.84697 15.2438V11.7001C7.8751 10.7157 7.0876 9.92822 6.10322 9.92822ZM6.60947 15.272C6.60947 15.5532 6.38447 15.7782 6.10322 15.7782H2.53135C2.2501 15.7782 2.0251 15.5532 2.0251 15.272V11.7001C2.0251 11.4188 2.2501 11.1938 2.53135 11.1938H6.10322C6.38447 11.1938 6.60947 11.4188 6.60947 11.7001V15.272Z"
        fill=""
      />
      <path
        d="M15.4689 9.92822H11.8971C10.9408 9.92822 10.1533 10.7157 10.1533 11.672V15.2438C10.1533 16.2001 10.9408 16.9876 11.8971 16.9876H15.4689C16.4252 16.9876 17.2127 16.2001 17.2127 15.2438V11.7001C17.2127 10.7157 16.4252 9.92822 15.4689 9.92822ZM15.9752 15.272C15.9752 15.5532 15.7502 15.7782 15.4689 15.7782H11.8971C11.6158 15.7782 11.3908 15.5532 11.3908 15.272V11.7001C11.3908 11.4188 11.6158 11.1938 11.8971 11.1938H15.4689C15.7502 11.1938 15.9752 11.4188 15.9752 11.7001V15.272Z"
        fill=""
      />
    </svg>
  );
};
const EmployeeIcon = () => {
  return (
    <svg
      className="fill-current"
      width="18"
      height="18"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M38,28.9a.94.94,0,0,0-.28-.67l-6.63-6.63a.92.92,0,0,0-.26-.17V4.54a.93.93,0,0,0-.93-.93h-27A.93.93,0,0,0,2,4.54V40a.93.93,0,0,0,.93.93H27.26l3.45,3.44h2.67l-3.7-3.7a2.11,2.11,0,0,0,1.1-1.37,1,1,0,0,0,.19-.15.94.94,0,0,0,0-1.33L25.2,32.06a1.1,1.1,0,0,1,0-1.56,1.06,1.06,0,0,1,.61-.27l.06,0a1.09,1.09,0,0,1,.89.29L29.22,33h0l1.36,1.36A.94.94,0,1,0,31.92,33l-1.09-1.09V24l5.27,5.27v7.47a.94.94,0,0,0,.28.67l6.95,6.95H46l-8-8Zm-9,1.12-.85-.85a3,3,0,0,0-1.49-.8V8.16H6.36v26H24.67l4.05,4.06.28.28a.9.9,0,0,0,0,.3.23.23,0,0,1-.23.23H4.12a.23.23,0,0,1-.23-.23V5.73a.23.23,0,0,1,.23-.23h24.6a.23.23,0,0,1,.23.23ZM9.46,26.18V24.32h14v1.86Zm7.44,2.42v1.86H9.46V28.6Zm-7.44-6.7V20h14v1.86Zm0-4.28V15.77h14v1.86Zm0-4.28V11.49h14v1.86ZM15,37v-.32a.61.61,0,0,1,.65-.57h1.49a.61.61,0,0,1,.65.57V37a.61.61,0,0,1-.65.58H15.67A.61.61,0,0,1,15,37Z" />
    </svg>
  );
};
const OfferIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 122.68"
      fill="white"
      className="w-[18px]"
    >
      <g>
        <path
          class="st0"
          d="M12.27,56.72h23.88c0,0.06,0,0.13,0,0.19V88H5.91V62.54C5.91,59.34,8.78,56.72,12.27,56.72L12.27,56.72z M20.36,27.17c-5.33-3.73-8.68-8.45-9.94-12.65c-0.9-3.02-0.83-5.95,0.22-8.43c1.21-2.84,3.53-4.91,6.97-5.74 c4.81-1.17,12.29,0.51,22.2,7.25c1.26,0.86,3.54,2.45,5.78,4.02c2.65,1.85,5.22,3.65,7.39,5.15c2.31-2.27,5.47-3.68,8.96-3.68 c3.82,0,7.24,1.68,9.58,4.33c2.35-1.62,5.29-3.68,8.33-5.81c2.24-1.57,4.53-3.17,5.78-4.02c9.9-6.74,17.39-8.42,22.2-7.25 c3.44,0.84,5.76,2.9,6.97,5.74c1.05,2.48,1.12,5.42,0.22,8.43c-1.26,4.2-4.61,8.92-9.94,12.65h13.48c2.37,0,4.31,1.8,4.31,4v14.51 c0,2.2-1.94,4-4.31,4H4.31c-2.37,0-4.31-1.8-4.31-4V31.17c0-2.2,1.94-4,4.31-4H20.36L20.36,27.17z M85.64,19.89 c-2.57,1.8-5.1,3.56-7.49,5.13c2.29-0.18,4.89-0.51,7.6-1.04c1.44-0.28,2.85-0.6,4.17-0.97c1.3-0.36,2.63-0.79,3.98-1.31l0.02-0.01 c6.57-2.52,10.39-6.67,11.41-10.07c0.23-0.76,0.29-1.32,0.18-1.59c-0.01-0.01-0.01-0.02-0.01-0.02l0,0.01 c0,0.03,0.02,0.14-0.03,0.13c-2.34-0.57-6.9,0.87-14.12,5.79C88.78,17.69,87.2,18.8,85.64,19.89L85.64,19.89z M105.5,10.02 C105.5,10.02,105.5,10.03,105.5,10.02L105.5,10.02L105.5,10.02z M47.31,25.02c-2.4-1.56-4.92-3.33-7.49-5.13 c-1.56-1.09-3.15-2.2-5.7-3.94c-7.22-4.92-11.78-6.36-14.12-5.79c-0.05,0.01-0.03-0.1-0.03-0.13l0,0c0,0,0,0-0.01,0.02 c-0.11,0.27-0.05,0.82,0.18,1.59c1.02,3.4,4.84,7.55,11.41,10.07l0.02,0.01c1.35,0.52,2.69,0.95,3.98,1.31 c1.33,0.37,2.73,0.69,4.17,0.97C42.42,24.5,45.02,24.84,47.31,25.02L47.31,25.02z M47.51,56.72h63.09c3.5,0,6.36,2.62,6.36,5.81V88 H47.52V56.92C47.52,56.85,47.52,56.79,47.51,56.72L47.51,56.72z M116.97,99.52v17.34c0,3.19-2.86,5.81-6.36,5.81H47.52V99.52 H116.97L116.97,99.52z M36.15,122.68H12.27c-3.49,0-6.36-2.61-6.36-5.81V99.52h30.24V122.68L36.15,122.68z"
        />
      </g>
    </svg>
  );
};
const BookingIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 122.88"
      fill="white"
      className="w-[19px]"
    >
      <g>
        <path d="M1.48,78.38l76.9-76.9l0,0C79.36,0.49,80.65,0,81.95,0c1.29,0,2.59,0.49,3.57,1.48l0,0l10.17,10.17 c0.55,0.55,0.61,1.4,0.17,2.01c-1.12,1.87-1.55,4.05-1.3,6.16c0.25,2.09,1.18,4.12,2.78,5.72c1.61,1.61,3.63,2.54,5.72,2.78 c2.14,0.26,4.35-0.2,6.24-1.36c0.63-0.38,1.42-0.27,1.92,0.23l0,0l10.17,10.17l0,0c0.98,0.98,1.48,2.28,1.48,3.57 c0,1.29-0.49,2.59-1.48,3.57l0,0l-76.9,76.9l0,0c-0.98,0.98-2.28,1.48-3.57,1.48c-1.29,0-2.59-0.49-3.57-1.48l0,0L27.25,111.3 c-0.56-0.56-0.61-1.44-0.15-2.05c1.22-1.89,1.73-4.12,1.51-6.28c-0.22-2.15-1.15-4.24-2.81-5.89c-1.65-1.65-3.74-2.59-5.89-2.81 c-2.2-0.22-4.45,0.3-6.36,1.56c-0.63,0.42-1.46,0.32-1.97-0.2l0,0L1.48,85.52l0,0C0.49,84.53,0,83.24,0,81.95 C0,80.65,0.49,79.36,1.48,78.38L1.48,78.38L1.48,78.38z M80.6,3.7L3.7,80.6l0,0c-0.37,0.37-0.55,0.86-0.55,1.35 c0,0.49,0.18,0.98,0.55,1.35l0,0l9.25,9.25c2.26-1.18,4.8-1.65,7.28-1.4c2.85,0.29,5.63,1.52,7.8,3.7c2.18,2.18,3.41,4.95,3.7,7.8 c0.25,2.48-0.21,5.02-1.4,7.28l9.25,9.25l0,0c0.37,0.37,0.86,0.55,1.35,0.55c0.49,0,0.98-0.18,1.35-0.55l0,0l76.9-76.9l0,0 c0.37-0.37,0.55-0.86,0.55-1.35c0-0.49-0.18-0.98-0.55-1.35l0,0l-9.34-9.34c-2.24,1.09-4.73,1.49-7.15,1.2 c-2.77-0.33-5.45-1.56-7.58-3.68c-2.12-2.12-3.35-4.81-3.68-7.58c-0.29-2.42,0.11-4.91,1.2-7.15L83.3,3.7l0,0 c-0.37-0.37-0.86-0.55-1.35-0.55C81.46,3.14,80.97,3.33,80.6,3.7L80.6,3.7L80.6,3.7z M25.26,73.45l38.37-38.37l0,0 c1.09-1.09,2.54-1.64,3.98-1.64c1.45,0,2.89,0.55,3.98,1.64l0,0l17.64,17.64c1.1,1.1,1.64,2.54,1.64,3.98 c0,1.44-0.55,2.89-1.64,3.98L50.86,99.05c-1.1,1.1-2.54,1.64-3.98,1.64c-1.44,0-2.88-0.55-3.98-1.64L25.26,81.42l0,0 c-1.1-1.1-1.64-2.54-1.64-3.98S24.17,74.55,25.26,73.45L25.26,73.45L25.26,73.45z M65.86,37.3L27.48,75.67l0,0 c-0.48,0.48-0.72,1.12-0.72,1.76c0,0.64,0.24,1.28,0.72,1.76l0,0l17.64,17.64c0.48,0.48,1.12,0.72,1.76,0.72 c0.64,0,1.28-0.24,1.76-0.72l38.37-38.37c0.48-0.48,0.72-1.12,0.72-1.76c0-0.64-0.24-1.28-0.72-1.76L69.38,37.3l0,0 c-0.49-0.49-1.12-0.73-1.76-0.73C66.98,36.57,66.34,36.82,65.86,37.3L65.86,37.3L65.86,37.3z" />
      </g>
    </svg>
  );
};
export const sidebarData = [
  {
    id: 1,
    mainTitle: "MENU",
    users: [0, 1, 2],
    menuOptions: [
      {
        id: 1,
        isSecured: false,
        users: [0, 1, 2],
        icon: <DashboardIcon />,
        title: "Dashboard",
        route: "/dashboard",
        isDrop: false,
      },

      {
        id: 2,
        isSecured: false,
        users: [0, 1, 2],
        icon: <BookingIcon />,
        title: "Add Booking",
        route: "/booking/add",
        isDrop: false,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "LIST",
    users: [0, 1],
    menuOptions: [
      {
        id: 8,
        isSecured: true,
        users: [0, 1],
        icon: <OfferIcon />,
        title: "Offers",
        route: "/offers",
        isDrop: true,
        subMenuOptions: [
          {
            id: 1,
            title: "Offers List",
            route: "/offers",
          },
          {
            id: 2,
            title: "Add New Offer",
            route: "/offers/add",
          },
        ],
      },
      {
        id: 9,
        isSecured: true,
        users: [0, 1],
        icon: <EmployeeIcon />,
        title: "Contact",
        route: "/contact",
        isDrop: false,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "OTHERS",
    users: [0, 1, 2],
    menuOptions: [
      {
        id: 1,
        isSecured: true,
        users: [0],
        icon: <EmployeeIcon />,
        title: "Admin",
        route: "/admin",
        isDrop: true,
        subMenuOptions: [
          {
            id: 1,
            title: "Admin List",
            route: "/admin",
          },
          {
            id: 2,
            title: "Add New Admin",
            route: "/admin/add",
          },
        ],
      },
      {
        id: 2,
        isSecured: false,
        users: [0, 1, 2],
        icon: <EmployeeIcon />,
        title: "Profile",
        route: "/profile",
        isDrop: false,
      },
    ],
  },
];
